import { ForwardedRef, forwardRef } from 'react';
import { Textarea } from '@components/textarea';
import classNames from 'classnames';

import { Props } from './textarea-counter.types';

export const TextareaCounter = forwardRef(
  (
    { hasError, length, maxLength, charactersText, readOnly, children, onChange, helperText, ...props }: Props,
    ref: ForwardedRef<HTMLTextAreaElement>
  ) => {
    const counterClasses = classNames({
      'text-tertiary': !hasError,
      'text-critical-no-bg': hasError,
    });

    const isOverMaxLength = length > maxLength;

    return (
      <div>
        <Textarea readOnly={readOnly} {...props} hasError={hasError} ref={ref} onChange={onChange} />
        <div
          className={`flex flex-row w-full mt-1.5 justify-between items-center text-body-m ${counterClasses}`}
          data-testid='textarea-counter'>
          {children}
          <p className={classNames('ml-auto text-body-xs gap-1.5', { 'flex w-full justify-between': helperText })}>
            {helperText && <span>{helperText}</span>}
            <span className={classNames({ 'text-critical-no-bg': isOverMaxLength, 'text-tertiary': !isOverMaxLength })}>
              {length}/{maxLength}
            </span>
          </p>
        </div>
      </div>
    );
  }
);
